/** @format */
import React, { FunctionComponent } from 'react';

import { JourneyBoundary } from '../journey-boundary';
import { KitSection } from './components/kit-section';
import { KitIntelligenceSectionProps } from './config/types';

export * from './config/constants';
export type { KitIntelligenceSectionProps } from './config/types';

/**
 * Wrapped in the same `JourneyBoundary` the journey uses: this is an
 * experiment in the middle of a page that sells things, so a failure while
 * rendering it stops here rather than taking the page down.
 */
export const KitIntelligenceSection: FunctionComponent<
    KitIntelligenceSectionProps
> = (props) => (
    <JourneyBoundary>
        <KitSection {...props} />
    </JourneyBoundary>
);
